export function parseFormattedRut(rut: string): string {
  return rut.replace(/\./g, "");
}
